export let OemModalFieldsJSON = {
  "1720177249476-documentFile": {
    elementid: 1720177249476,
    elementtype: "documentFile",
    "display-fieldlabel": "Logo",
    "display-labelposition": "top",
    "database-label": "logo_media_id",
    // "display-required": 1,
    "validation-filepattern": ".jpeg,.jpg,.png,.webp,.svg,.gif",
  },
  "1720177264442-customSelect": {
    elementid: 1720177264442,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-required": 1,
    "display-labelposition": "top",
    "display-placeholder": "Select",
  },
  "1720177239560-textarea": {
    elementid: 1720177239560,
    elementtype: "textarea",
    "display-rows": "3",
    "display-fieldlabel": "Description",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
  },
  "1720177234978-textfield": {
    elementid: 1720177234978,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
};

export const UploadFieldsJSON = {
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Logo",
    "display-required": 0,
    "database-label": "logo_media_id",
    "display-labelposition": "top",
  },
};
